<ion-content>
  <ion-grid class="ion-no-padding" style="height: 100%">
    <ion-row class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
      style="height: 100%; flex-direction: column">
      <div style="width: 95%;">
        <ion-card class="ion-margin-bottom no-shadow ion-text-center">
          <ion-card-title class="font16 ion-padding-bottom card-primary-text-color">{{"page_status.no_birthday.header" | translate}}
          </ion-card-title>
          <ion-img [src]="'assets/images/no-birthday.png'" style="max-width: 250px; width:100%; margin: auto;">
          </ion-img>
          <ion-card-subtitle class="font12 ion-padding-top card-secondary-text-color">{{"page_status.no_birthday.privileges_activates" | translate}}
          </ion-card-subtitle>
          <!-- <ion-text color="danger" class="ion-margin-borrom">
            <p>X Concierge Team Will Get In Touch With You</p>
          </ion-text> -->
        </ion-card>
      </div>
    </ion-row>
  </ion-grid>
</ion-content>